export default __webpack_public_path__ + "static/media/2352.0e4e07ff.png";